export default __webpack_public_path__ + "static/hackaway-logo-d4c9db7be251d4c256f5e3b9fc4c25c7.png";